module.exports = __webpack_public_path__ + "img/light-bulb-icon.41aa2340.svg";